import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { View } from 'foundations-components/transitional/components/View';
import { ILLUSTRATIONS, IMAGE_BACKGROUND_OVERRIDES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const RecommendedPopularFeaturePanelImage = ({
  featureRecord
}) => featureRecord ? /*#__PURE__*/_jsx(View, {
  textAlign: "center",
  inlineSize: "100%",
  backgroundColor: featureRecord.shortName in IMAGE_BACKGROUND_OVERRIDES ? IMAGE_BACKGROUND_OVERRIDES[featureRecord.shortName] : 'fill-accent-yellow-subtle',
  children: ILLUSTRATIONS[featureRecord.shortName] === 'whatsapp' ? /*#__PURE__*/_jsx(Logo, {
    name: ILLUSTRATIONS[featureRecord.shortName],
    height: 132,
    marginBlock: "200"
  }) : /*#__PURE__*/_jsx(Illustration, {
    name: ILLUSTRATIONS[featureRecord.shortName],
    height: 132,
    marginBlock: "200"
  })
}) : null;
export default RecommendedPopularFeaturePanelImage;